<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>Wireless</span></p>
<p class="authorname"><span>Jack O’Connell</span></p>
<p class="publisher"><span>A <a href="http://www.MysteriousPress.com" target="_blank">MysteriousPress.com</a><br/>Open Road Integrated Media ebook</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?653d4d16